import MarkdownRenderer from '../Markdown/MarkdownRenderer';

const PrivacyContentFromMarkdown = () => {
  

  return (
    <div>
      <MarkdownRenderer file="/content/privacy-policy.md" />
    </div>
  );
};

export default PrivacyContentFromMarkdown;
